import React from "react";

import type { RebookSliceOriginProps } from "./types";

export const useRebookSliceOrigin = ({
  slice,
  airports,
}: RebookSliceOriginProps) => {
  const firstSegment = React.useMemo(() => slice.segments[0], [slice]);
  const originCode = React.useMemo(
    () => firstSegment.origin.locationCode,
    [firstSegment]
  );
  const originName = React.useMemo(
    () => airports[originCode]?.cityName ?? originCode,
    [airports, originCode]
  );

  return React.useMemo(
    () => ({
      text: {
        originCode,
        originName,
      },
    }),
    [originCode, originName]
  );
};
